// extracted by mini-css-extract-plugin
export default {"Maincontainer":"styles_Maincontainer__fshgV","container":"styles_container__quF2s"};